import {
  EnvelopesProvider,
  Report as LibraryReport,
  UrlSearchProvider,
} from '@cucumber/react-components'
import { useParams } from 'react-router-dom'

import { Ad } from '../components/Ad.tsx'
import { useDelete } from '../hooks/useDelete.ts'
import { useEnvelopes } from '../hooks/useEnvelopes.ts'

function Report() {
  const { id } = useParams<{ id: string }>()
  const { data: envelopes = [], isFetching, isError } = useEnvelopes(id as string)
  const { mutate } = useDelete(id as string)
  const handleDelete = () => mutate()

  if (isFetching) {
    return (
      <main className="flex-grow w-full max-w-7xl p-8 mx-auto">
        <p className="text-center">Just a moment...</p>
      </main>
    )
  }

  if (isError) {
    return (
      <main className="flex-grow w-full max-w-7xl p-8 mx-auto">
        <div className="text-center">
          <h1 className="text-3xl font-bold">No report found</h1>
          <p>It might have expired, or been deleted.</p>
        </div>
      </main>
    )
  }

  return (
    <main className="flex-grow w-full max-w-7xl p-8 mx-auto">
      <header className="flex items-center justify-between gap-8 mb-8">
        <div>
          <h1 className="text-5xl font-light mb-2">
            Your report from <strong className="font-bold">Cucumber</strong>
          </h1>
          <p className="text-xl">
            It will be automatically deleted after 24 hours.{' '}
            <button
              type="button"
              onClick={handleDelete}
              className="bg-red-700 text-white text-sm px-2 py-1 rounded-sm ml-1 cursor-pointer"
            >
              Delete it now
            </button>
          </p>
        </div>
        <Ad />
      </header>
      <article data-testid="report">
        <EnvelopesProvider envelopes={envelopes}>
          <UrlSearchProvider>
            <LibraryReport />
          </UrlSearchProvider>
        </EnvelopesProvider>
      </article>
    </main>
  )
}

export default Report
